var render = function () {
  var _vm$report$workShopCo, _vm$workshopContractD, _vm$workshopContract, _vm$workshopContractD2, _vm$workshopContract2, _vm$workshopContractD3, _vm$workshopContractD4, _vm$workshopContractD5;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportSelectWorkshopCard.title")) + " "), _c('v-spacer'), _vm.canUpdateReport && _vm.canReadCompany ? _c('m-icon-button', {
    attrs: {
      "icon": _vm.selectWorkShopIcon,
      "disabled": _vm.report.isWorkshopCompanyLoading || _vm.isUpdatingReport
    },
    on: {
      "click": _vm.openDialog
    }
  }) : _vm._e()], 1), _c('v-card-text', [!_vm.reportWorkshopId ? _c('m-no-content', {
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportSelectWorkshopCard.noWorkshopText')
    }
  }) : _vm.report.isWorkshopCompanyLoading || _vm.isUpdatingReport ? _c('v-skeleton-loader', {
    staticClass: "mb-2",
    attrs: {
      "type": "image",
      "height": "124"
    }
  }) : _vm.report.workShopCompany ? _c('company-sheet', {
    attrs: {
      "company": _vm.report.workShopCompany
    }
  }, [_vm.canReadContract ? _c('m-expansion', {
    staticClass: "mx-4 mb-2 mt-n4",
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportSelectWorkshopCard.conditions")) + " ")];
      },
      proxy: true
    }], null, false, 1774888366),
    model: {
      value: _vm.showDetails,
      callback: function callback($$v) {
        _vm.showDetails = $$v;
      },
      expression: "showDetails"
    }
  }, [_vm.report.isWorkshopCompanyLoading || _vm.isUpdatingReport || (_vm$report$workShopCo = _vm.report.workShopCompany) !== null && _vm$report$workShopCo !== void 0 && _vm$report$workShopCo.isContractsLoading ? _c('v-skeleton-loader', {
    staticClass: "mb-2",
    attrs: {
      "type": "image",
      "height": "124"
    }
  }) : _vm.workshopContractDetails ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": typeof ((_vm$workshopContractD = _vm.workshopContractDetails) === null || _vm$workshopContractD === void 0 ? void 0 : _vm$workshopContractD.paintHourlyBillingRate) === 'number' ? _vm.workshopContractDetails.paintHourlyBillingRate.toLocaleString('de-DE', {
        style: 'currency',
        currency: (_vm$workshopContract = _vm.workshopContract) === null || _vm$workshopContract === void 0 ? void 0 : _vm$workshopContract.currency
      }) : '',
      "label": _vm.$t('objects.contract.workshop.paintHourlyBillingRate'),
      "dense": "",
      "hide-details": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": typeof ((_vm$workshopContractD2 = _vm.workshopContractDetails) === null || _vm$workshopContractD2 === void 0 ? void 0 : _vm$workshopContractD2.mechanicalHourlyBillingRate) === 'number' ? _vm.workshopContractDetails.mechanicalHourlyBillingRate.toLocaleString('de-DE', {
        style: 'currency',
        currency: (_vm$workshopContract2 = _vm.workshopContract) === null || _vm$workshopContract2 === void 0 ? void 0 : _vm$workshopContract2.currency
      }) : '',
      "label": _vm.$t('objects.contract.workshop.mechanicalHourlyBillingRate'),
      "dense": "",
      "hide-details": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": typeof ((_vm$workshopContractD3 = _vm.workshopContractDetails) === null || _vm$workshopContractD3 === void 0 ? void 0 : _vm$workshopContractD3.paintMaterialPercentage) === 'number' ? (_vm.workshopContractDetails.paintMaterialPercentage / 100).toLocaleString('de-DE', {
        style: 'percent'
      }) : '',
      "label": _vm.$t('objects.contract.workshop.paintMaterialPercentage'),
      "dense": "",
      "hide-details": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": typeof ((_vm$workshopContractD4 = _vm.workshopContractDetails) === null || _vm$workshopContractD4 === void 0 ? void 0 : _vm$workshopContractD4.sparePartsDiscountPercentage) === 'number' ? (_vm.workshopContractDetails.sparePartsDiscountPercentage / 100).toLocaleString('de-DE', {
        style: 'percent'
      }) : '',
      "label": _vm.$t('objects.contract.workshop.sparePartsDiscountPercentage'),
      "dense": "",
      "hide-details": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": typeof ((_vm$workshopContractD5 = _vm.workshopContractDetails) === null || _vm$workshopContractD5 === void 0 ? void 0 : _vm$workshopContractD5.sparePartsSurchargePercentage) === 'number' ? (_vm.workshopContractDetails.sparePartsSurchargePercentage / 100).toLocaleString('de-DE', {
        style: 'percent'
      }) : '',
      "label": _vm.$t('objects.contract.workshop.sparePartsSurchargePercentage'),
      "dense": "",
      "hide-details": ""
    }
  })], 1)], 1) : _c('m-no-content', {
    staticClass: "mb-4",
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportSelectWorkshopCard.noWorkshopConditionsText'),
      "icon": "mdi-wrench-clock",
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    },
    scopedSlots: _vm._u([_vm.canUpdateReport && _vm.canReadContract ? {
      key: "actions",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "outlined": ""
          },
          on: {
            "click": _vm.goToWorkshopDetails
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportSelectWorkshopCard.addWorkshopCondition")) + " ")], 1)];
      },
      proxy: true
    } : null], null, true)
  })], 1) : _vm._e()], 1) : _c('m-no-content', {
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportSelectWorkshopCard.loadingError')
    }
  })], 1), _c('company-map-dialog', {
    attrs: {
      "title": "Werkstatt auswählen",
      "search": _vm.search
    },
    on: {
      "select": _vm.selectWorkshop
    },
    model: {
      value: _vm.selectWorkshopDialog,
      callback: function callback($$v) {
        _vm.selectWorkshopDialog = $$v;
      },
      expression: "selectWorkshopDialog"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }